"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractTicket = void 0;
var util_1 = require("../../util");
var types_1 = require("../types");
function extractTicket(query) {
    var ticket_id = util_1.tryGetValue(query.ticket_id);
    if (!ticket_id) {
        return;
    }
    var action = util_1.tryGetValue(query.action);
    return {
        name: 'ticket',
        ticket_id: ticket_id,
        action: isAction(action) ? action : undefined,
    };
}
exports.extractTicket = extractTicket;
function isAction(action) {
    return action != null && types_1.TicketActions.has(action);
}
